import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { PercentCompleteLine } from 'components/patterns/Charts'
import { MAX_CAN_INPUTS, MAX_SWITCH_INDICATORS } from 'utils/constants.js'
import withStyle from './ModuleSummary.style.js'

const maxBarWidth = 95

const ModuleSummaryMetricsPercentLineVariant = ({
  moduleName,
  logicCount,
  maxLogics,
  timerCount,
  maxTimers,
  pinCount,
  maxPins,
  showSwitchIndicator,
  maxSwitchIndicators,
  switchIndicatorCount,
  maxCanInputs = MAX_CAN_INPUTS,
  canInputsCount,
  showCanInputs,
}) => (
  <>
    <PercentCompleteLine
      label={`${strings.pins} ${strings.used}`}
      count={pinCount}
      total={maxPins}
      id={`${moduleName}-pins`}
      maxBarWidth={maxBarWidth}
    />
    <PercentCompleteLine
      label={`${strings.logic_sets} ${strings.used}`}
      count={logicCount}
      total={maxLogics}
      id={`${moduleName}-logics`}
      maxBarWidth={maxBarWidth}
    />
    <PercentCompleteLine
      label={`${strings.timers} ${strings.used}`}
      count={timerCount}
      total={maxTimers}
      id={`${moduleName}-timers`}
      maxBarWidth={maxBarWidth}
    />
    {showCanInputs && (
      <PercentCompleteLine
        label={`${strings.can_inputs}`}
        count={canInputsCount}
        total={maxCanInputs}
        id={`${moduleName}-canInputs`}
        maxBarWidth={maxBarWidth}
      />
    )}
    {showSwitchIndicator && (
      <PercentCompleteLine
        label={`${strings.switch_indicators}`}
        count={switchIndicatorCount || 0}
        total={maxSwitchIndicators || MAX_SWITCH_INDICATORS}
        id={`${moduleName}-switchIndicators`}
        maxBarWidth={maxBarWidth}
      />
    )}
  </>
)

ModuleSummaryMetricsPercentLineVariant.propTypes = {
  /** Make sure to comment */
  /** Name of the module (e.g. XMC/2) */
  moduleName: PropTypes.string,
  /** number of logicsets used by all feaures using this module on the vehicle */
  logicCount: PropTypes.number,
  /** max logicsets that can be used in total by all feaures using this module on the vehicle */
  maxLogics: PropTypes.number,
  /** number of timers used by all feaures using this module on the vehicle */
  timerCount: PropTypes.number,
  /** max timers that can be used in total by all feaures using this module on the vehicle */
  maxTimers: PropTypes.number,
  /** number of pins used by all feaures using this module on the vehicle */
  pinCount: PropTypes.number,
  /** max pins that can be used in total by all feaures using this module on the vehicle */
  maxPins: PropTypes.number,
  /** max switches that can be used in total by all feaures using this module on the vehicle */
  maxSwitchIndicators: PropTypes.number,
  /** number of switches used by all feaures using this module on the vehicle */
  switchIndicatorCount: PropTypes.number,
  /** for appVariant >= 118 switchIndicator count should be shown */
  showSwitchIndicator: PropTypes.bool,
  /** from XMC3-8 */
  showCanInputs: PropTypes.bool,
  maxCanInputs: PropTypes.number,
  canInputsCount: PropTypes.number,
}

export default withStyle(ModuleSummaryMetricsPercentLineVariant)
